export const previewData = [{
  title: 'Holidaze, Noroff final exam',
  description: 'A mockup site to locate and administer hotels, BnBs and similar establishments in the Bergen area.',
  image: 'holidaze',
  url: 'https://github.com/frankwaldal/noroff-project-exam2-frank-waldal'
},{
  title: 'Noroff JS Frameworks CA',
  description: 'Assignment at Noroff, site to browse and favorite mark different games.',
  image: 'jsfwca',
  url: 'https://github.com/frankwaldal/frank-s-waldal-js-frameworks-ca'
},{
  title: 'EnP Tracker and Planner',
  description: 'A learning and hobby project for a game. My first project done with React. First version done with class components, but since refactored to use function components and included the use of state.',
  image: 'enp',
  url: ''
},{
  title: 'Climb to Mist Mountain',
  description: 'Online boardgame with fantasy inspired theme, made for semester assignment may 2020 for Frontend Development course at Noroff. Created with nodejs backend and socketio for online gameplay, and makes use of canvas to render the gameboard.',
  image: 'mistMountain',
  url: 'https://github.com/frankwaldal/semesterProject2_onlineBoardgame'
},{
  title: 'Home Decor',
  description: 'Assignment at Noroff during the Design 2 course.',
  image: 'homeDecor',
  url: 'https://fwaldal.no/fed/design2/ma1'
},{
  title: 'Letha',
  description: 'Mockup webstore for shoes, portfolio delivery during first year at Noroff.',
  image: 'letha',
  url: 'https://fwaldal.no/fed/portfolio1/letha/'
},{
  title: 'Raufoss Community Science Museum',
  description: 'Mockup information site about science museum, portfolio delivery during first year at Noroff.',
  image: 'museum',
  url: 'https://fwaldal.no/fed/portfolio1/museum/'
},{
  title: 'A Mars Adventure',
  description: `Site about SpaceX' past and future launches, company history and rockets. Created as Project Exam for the first year at Noroff.`,
  image: 'marsAdventure',
  url: 'https://github.com/frankwaldal/project-exam1'
}];
